import { PricingOptionCard } from "./PricingOptionCard";
import SubmitButton from "components/SubmitButton";
import { BillingInputName } from "v2/dataroutes/BillingData";
import { useToasterFromActionData } from "hooks/useToasterFromActionData";
import { useCallbackAfterSubmission } from "v2/hooks/useCallbackAfterSubmission";
import { cx } from "utils";
import { useActiveSubscription } from "routes/data-routes/billing-data/active-subscription";
import { ActiveSubscriptionFormActions } from "routes/data-routes/billing-data/active-subscription/ActiveSubscriptionFormActions";
import {
  ActiveSubscriptionDataRoutePath
} from "routes/data-routes/billing-data/active-subscription/route.meta";


export function AnnualResubscribeContent(
  {
    showTitle = true,
    recommended = false,
    primary = true,
    afterSubmissionCallback,
    formFetcher: providedFetcher,
    isRedesign = false,
  }: {
    showTitle?: boolean;
    recommended?: boolean;
    primary?: boolean;
    afterSubmissionCallback?: () => void;
    formFetcher?: any;
    /**
     * Billing v2 callers pass true to omit the keepScheduledChanges hidden input
     * so the billing service can apply its smart default (keep only when the
     * scheduled target is Enterprise / Custom / Extended Trial). v1 callers leave
     * it false to preserve the legacy hardcoded-true behavior.
     */
    isRedesign?: boolean;
  }
) {
  const { activeSubscription, activeSubscriptionFetcher } = useActiveSubscription();

  // Use provided fetcher if available, otherwise fall back to activeSubscriptionFetcher
  const formFetcher = providedFetcher || activeSubscriptionFetcher;

  useToasterFromActionData(formFetcher);

  useCallbackAfterSubmission(afterSubmissionCallback, formFetcher);

  if (activeSubscription?.billingProvider === "stripe") {
    return null;
  }


  // TODO should we check here if we really are on a yearly plan?

  return (
    <PricingOptionCard
      recommended={ recommended }
      title={ showTitle ? "Resubscribe" : undefined }
      body="Get a fresh credit allowance immediately"
      features={ [ "Annual billing cycle restarts", "Same plan features" ] }
      footer={
        <formFetcher.Form
          method="POST"
          action={ ActiveSubscriptionDataRoutePath }
        >
          <input type="hidden"
                 name={ BillingInputName.chargebeeSubscriptionId }
                 value={ activeSubscription?.chargebeeSubscriptionId ?? " " /* avoiding component changing from uncontrolled to controlled warnings */ }
          />
          { !isRedesign && (
            /* v1 behaviour: always send keepScheduledChanges=true. Hardcoding it
               was necessary before the billing service gained a smart default.
               v2 (isRedesign) omits this input so the service chooses per the
               scheduled target's plan type — fixing a yearly→monthly scheduled
               downgrade firing immediately on resubscribe. */
            <input type="hidden"
                   name={ BillingInputName.keepScheduledChanges }
                   value="true"
            />
          ) }
          <SubmitButton
            text="Resubscribe now"
            className={ cx("mt-5 w-full button", primary ? "button-primary" : "button-secondary") }
            size="MD"
            fetchersToCheck={ [ formFetcher ] }
            { ...ActiveSubscriptionFormActions.renew }
            disabled={ formFetcher?.state === "loading" && !!formFetcher?.formData }
          />
        </formFetcher.Form>
      }
    />
  );
}
